// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"07055bf8","134":"43f38f74","335":"14b37608","631":"562baa03","755":"38c4dd80","787":"ab1b598a"}[chunkId] + ".chunk.js";
};